import React, { useEffect, useContext } from 'react';
import Button from '../../../../../components/UI/Button';
import css from './delayed.module.scss';
import { getPlanNameText } from '../../helpers';
import TaskList from '../../UI/TaskList';
import { CreditApplicationStatus } from '../../../../../services/credit';
import { AnalyticsContext } from '../../../../../ModularReduxAnalytics';

export default function Delayed({ planName, registrationToken, answer }) {
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Credit Application Delayed');
  }, []);

  const submitDelayedAnswer = () => {
    answer({
      accessToken: registrationToken,
      questions: ['credit_application'],
      answers: [
        {
          credit_accepted: false,
          credit_decision: CreditApplicationStatus.DELAYED
        }
      ]
    });
  };
  const planNameText = getPlanNameText(planName);
  const tasks = [
    { completed: true, text: 'Create a Greenlight account' },
    { completed: true, text: 'Apply for the Family Cash Card' },
    { completed: false, text: 'Link your payment account' }
  ];

  return (
    <div className={css.delayedContainer}>
      <img
        className={css.delayedIcon}
        alt="Checkmark in circle"
        src="/static/squigglycirclecheckmark.svg"
      />
      <h1>We are reviewing your application</h1>
      <div className={css.subheadingContainer}>
        <h2 className={css.subheading}>
          Your application has been received. Our partner bank, First National
          Bank of Omaha (FNBO®), will contact you for a few additional details.
          When a decision has been made, you’ll receive a notification in the
          Greenlight app. Decisions typically take within 3-5 business days.
        </h2>
        <h2>
          {`In the meantime, you have a 1-month free trial with ${planNameText}. Get debit cards for up to 5 kids, send money, set up chores, invest as a family, and more.`}
        </h2>
        <TaskList tasks={tasks} />
        <Button
          data-testid="delayed-button"
          text={`Continue with ${planNameText}`}
          onClick={() => {
            analytics.trackEvent('Credit Action', {
              eventProps: {
                type: 'Continue',
                page: 'Credit Application Delayed'
              }
            });
            submitDelayedAnswer();
          }}
        />
      </div>
    </div>
  );
}
